/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  EnvironmentHealthcheck,
  EnvironmentHealthcheck$inboundSchema,
} from "./environmenthealthcheck.js";
import {
  EnvironmentShutdownSignal,
  EnvironmentShutdownSignal$inboundSchema,
} from "./environmentshutdownsignal.js";
import {
  EnvironmentUpstreamProtocol,
  EnvironmentUpstreamProtocol$inboundSchema,
} from "./environmentupstreamprotocol.js";

export type DeploymentRuntime = {
  /**
   * CPU allocation in vCPUs (1 = one vCPU, 0.5 = half a vCPU).
   *
   * @remarks
   */
  vCpus: number;
  /**
   * Memory allocation in mebibytes.
   *
   * @remarks
   */
  memoryMib: number;
  /**
   * Ephemeral storage allocation in mebibytes.
   *
   * @remarks
   */
  storageMib: number;
  /**
   * Port the container listens on.
   *
   * @remarks
   */
  port: number;
  /**
   * Container entrypoint command override. Empty when none is set.
   *
   * @remarks
   */
  command: Array<string>;
  /**
   * Signal sent to the container on shutdown.
   *
   * @remarks
   */
  shutdownSignal: EnvironmentShutdownSignal;
  /**
   * Protocol used to reach the container.
   *
   * @remarks
   */
  upstreamProtocol: EnvironmentUpstreamProtocol;
  healthcheck?: EnvironmentHealthcheck | undefined;
};

/** @internal */
export const DeploymentRuntime$inboundSchema: z.ZodType<
  DeploymentRuntime,
  z.ZodTypeDef,
  unknown
> = z.object({
  vCpus: z.number(),
  memoryMib: z.number().int(),
  storageMib: z.number().int(),
  port: z.number().int(),
  command: z.array(z.string()),
  shutdownSignal: EnvironmentShutdownSignal$inboundSchema,
  upstreamProtocol: EnvironmentUpstreamProtocol$inboundSchema,
  healthcheck: EnvironmentHealthcheck$inboundSchema.optional(),
});

export function deploymentRuntimeFromJSON(
  jsonString: string,
): SafeParseResult<DeploymentRuntime, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeploymentRuntime$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeploymentRuntime' from JSON`,
  );
}
